<template>
<div>
  <Row class="loading" :style="loading==true ? '' : 'display:none'">
    <Col class="demo-spin-col" span="8">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>加载中</div>
      </Spin>
    </Col>
  </Row>
<!--  <v-divider></v-divider>-->
  <v-simple-table :height="__TABLE_HEIGHT__">
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left">ID</th>
        <th class="text-left">客户姓名</th>
        <th class="text-left">房产</th>
        <!-- <th class="text-left">租赁合同</th> -->
        <th class="text-left">押金类型</th>
        <th class="text-left">收取日期</th>
        <th class="text-left">收取押金</th>
        <th class="text-left">退还日期</th>
        <th class="text-left">退还押金</th>
        <th class="text-left">押金余额</th>
        <!-- <th class="text-left">挂账金额</th> -->
        <th class="text-left">票据号码</th>
        <th class="text-left">备注</th>
        <th class="text-left">添加时间</th>
        <th class="text-left">操作</th>
      </tr>
      </thead>
      <tbody>
      <tr class="text1" v-for="item in data">
        <td >{{item.id}}</td>
        <td >{{item.name}}</td>
        <td >{{item.house}}</td>
        <!-- <td >{{item.rent_contract}}</td> -->
        <td >{{item.deposit_type}}</td>
        <td >{{item.charge_date}}</td>
        <td >{{item.charge_money}}</td>
        <td >{{item.retreat_date}}</td>
        <td >{{item.retreat_money}}</td>
        <td >{{item.deposit_money}}</td>
        <!-- <td >{{item.account_money}}</td> -->
        <td >{{item.bill_number}}</td>
        <td >{{item.beizhus}}</td>
        <td >{{item.date}}</td>
        <td class="cdj_td">
          <div style="cursor:pointer;">
<!--            <div @click="tui(item)" style="color: #1e73e9;">退押金</div>-->
          </div>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
  <v-divider></v-divider>
  <div class="pages" v-if="data">
    <Page :total="count" :page-size="pageSize" @on-change="change"  show-total />
  </div>
  <div class="zhanwu" v-else>没有数据</div>
</div>
</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js"
export default {
  name: "finance-deposit",
  props:{
    customer_id:{
      type:Number,
      default(){
        return 0
      }
    },
    house_id:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  data () {
    return {
      maskclosable:false,
      modal:false,
      modal2:false,
      statesModal:false,
      loading:false,
      loadingModal:true,
      unlinkpanels:true,
      options: [],
      payment:[],
      charge:[],
      house:[],
      count:0,
      pageSize:12,
      data: '',
      pid: '',
      text:'',
      state:'1',
      url:'',
      fileList:[],
      form:{
        pindex_id:'',
        house_id:'',
        name:'',
        house:'',
        business_type:1,
        payment_name:'',
        deposit_type:'',
        charge_money:'',
        charge_date:'',
        bill_type:'',
        bill_number:'',
        beizhus:''
      },
      statesForm:{
        id:'',
        payment_name:'',
        retreat_money:'',
        retreat_date:'',
        remarks:'',
      },
      deposit_type:[],
      date:'',
      bill_type:[
        {
          id:1,
          name:'收据'
        },
        {
          id:2,
          name:'中奥收据'
        },
        {
          id:3,
          name:'电子发票'
        },
        {
          id:4,
          name:'资金往来发票'
        },
        {
          id:5,
          name:'定额发票20元'
        },
        {
          id:6,
          name:'增值税专用发票'
        },
        {
          id:7,
          name:'服务业通用发票'
        },
        {
          id:8,
          name:'停车场专用发票'
        },
        {
          id:9,
          name:'红字发票'
        },
        {
          id:10,
          name:'增值税普通发票'
        },
        {
          id:11,
          name:'定额发票5元'
        },
        {
          id:12,
          name:'系统导入票据'
        },
        {
          id:13,
          name:'定额发票1元'
        },
        {
          id:14,
          name:'中奥-收据'
        }
      ]
    }
  },
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel?"+"login_name="+login+"&token="+token;
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.options = backdata.data.data;
    });
    this.change(1);
    //加载收款方式
    this.$myhttp.get('admin/common/payment',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.payment = backdata.data.data;
    });
    //押金类型
    this.$myhttp.get('admin/common/deposit_type',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.deposit_type = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  methods: {
    modals(){
      this.modal = true;
    },
    //分页
    change(page){
      this.loading = true;
      this.loading = false;
      this.$myhttp.get('admin/CustomerManagement/financeDeposit?page='+page+ '&state='+ this.state+'&text='+this.text+'&pid='+this.pid+'&house_id='+this.house_id+'&customer_id='+this.customer_id,{
        'Content-Type': 'application/json'
      }).then(backdata=>{
        let data = backdata.data;
        this.data = data.data.data;
        this.count = data.data.count;
        this.pageSize = data.data.pageSize;
        this.loading = false;
      });
    },
  },

}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #3e3f42 !important;
  cursor: not-allowed;
}
</style>

<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/finance/finance-deposit.vue